/* bb-share-cart.js — native "Share cart" via Shopify cart permalink.
 * BarrierBoss 2026-07. Replaces the uninstalled Share Cart app.
 * Builds  /cart/{variantId}:{qty},{variantId}:{qty}...  from the live cart,
 * then uses the Web Share sheet (mobile) or copies the link (desktop).
 * No app, no deps. Wire a trigger with [data-bb-share-cart] or #bbShareCart.
 */
(function () {
  if (window.__bbShareCart) return;
  window.__bbShareCart = true;

  function buildPermalink() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;
        var parts = cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; });
        return location.origin + '/cart/' + parts.join(',');
      });
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText =
      'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#222;' +
      'color:#fff;padding:10px 18px;border-radius:24px;font:600 14px/1.3 Oswald,sans-serif;' +
      'z-index:100000;box-shadow:0 4px 16px rgba(0,0,0,.3);opacity:0;transition:opacity .2s;';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 250); }, 2200);
  }

  function share(trigger) {
    buildPermalink().then(function (url) {
      if (!url) { toast('Your cart is empty'); return; }
      var title = document.title || 'My BarrierBoss cart';
      if (navigator.share) {
        navigator.share({ title: title, text: 'Here is my BarrierBoss cart:', url: url })
          .catch(function () { copy(url); });
      } else {
        copy(url);
      }
    }).catch(function () { toast('Could not build cart link'); });
  }

  function copy(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () { toast('Cart link copied!'); },
        function () { prompt('Copy your cart link:', url); }
      );
    } else {
      prompt('Copy your cart link:', url);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bb-share-cart], #bbShareCart');
    if (!trigger) return;
    e.preventDefault();
    share(trigger);
  });
})();
